<template>
  <div>
    <el-dialog
      :visible.sync="combinationVisible"
      title="组合图片"
      width="540px"
      @cancel="updateVal"
      @close="updateVal"
    >
      <div class="imgAll">
        <div class="img-box" v-for="(item,index) in ombinationData" :key="index">
          <div>
            <el-image
              height="500px"
              :src="item.photoUrl ? item.photoUrl : img_err"
              fit="contain"
              arrow="always"
              :autoplay="false"
              class="pic-item"
              @click="add(item)"
            ></el-image>
            <el-card class="text-box">
              <div>{{item.categoryName}}</div>
          </el-card>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { assignValue } from "@/utils";
import img_err from '@/assets/images/img_err.png'
export default {
  model: {
    prop: "visible",
    event: "input",
  },
  props: {
    visible: Boolean,
    ombinationData: Array
  },
  computed: {
  },
  data() {
    return {
      combinationVisible: false,
      img_err
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.combinationVisible = this.visible;
    },
    updateVal() {
      setTimeout((_) => {
        this.$emit("combinationNone", false);
      }, 200);
    },
  },
};
</script>

<style lang="stylus" scoped>
.imgAll {
  max-height: 600px;
  display: flex
  flex-wrap: wrap
  overflow-x: hidden
  // background: blue;
}

.img-box {
  padding: 0 10px 10px 0;
  width: 240px;
  // background: red;
}

.pic-item
    width 240px
    height 240px

.text-box {
  width 240px
  height: 40px
  line-height: 40px
}

.text-box div {
  text-align: center
  font-size: 16px
  font-weight: 500
}

>>> .el-card__body {
  padding: 0
  background: #F4F4F4;
}
</style>>

